import {
    UPDATE_ACCESS_LOG,
    APPEND_ACCESS_LOG,
    FETCH_MORE_LOGS,
    MERGE_ACCESS_LOG,
    ACCESS_LOG_ERROR,
    FETCH_ACCESS_LOG_LPR_DOC,
    FETCH_ACCESS_LOG_LPR_DOC_SUCCESS,
    FETCH_ACCESS_LOG_LPR_DOC_ERROR,
    CLEAR_ACCESS_LOG_LPR_DOC,
    FETCH_ACCESS_LOG_DEVICE,
    FETCH_ACCESS_LOG_DEVICE_SUCCESS,
    FETCH_ACCESS_LOG_DEVICE_ERROR,
    CLEAR_ACCESS_LOG_DEVICE,
    FETCH_ACCESS_LOG_ACCESS_KEY,
    FETCH_ACCESS_LOG_ACCESS_KEY_SUCCESS,
    FETCH_ACCESS_LOG_ACCESS_KEY_ERROR,
    CLEAR_ACCESS_LOG_ACCESS_KEY,
    FETCH_ACCESS_LOG_GUARD_IDENTITY,
    FETCH_ACCESS_LOG_GUARD_IDENTITY_SUCCESS,
    FETCH_ACCESS_LOG_GUARD_IDENTITY_ERROR,
    CLEAR_ACCESS_LOG_GUARD_IDENTITY,
    FETCH_ACCESS_LOG_APPROVER_INVITE,
    FETCH_ACCESS_LOG_APPROVER_INVITE_SUCCESS,
    FETCH_ACCESS_LOG_APPROVER_INVITE_ERROR,
    CLEAR_ACCESS_LOG_APPROVER_INVITE
} from 'store/actions/types';

export const fetchMoreAccessLogs = data => {
    return {
        type: FETCH_MORE_LOGS,
        payload: data
    };
};

export const updateAccessLog = logs => ({
    type: UPDATE_ACCESS_LOG,
    payload: logs
});

export const appendAccessLog = logs => ({
    type: APPEND_ACCESS_LOG,
    payload: logs
});

export const mergeAccessLog = logs => ({
    type: MERGE_ACCESS_LOG,
    payload: logs
});

export const accessLogError = message => ({
    type: ACCESS_LOG_ERROR,
    payload: message
});

export const fetchAccessLogLprDoc = id => ({
    type: FETCH_ACCESS_LOG_LPR_DOC,
    payload: id
});

export const fetchAccessLogLprDocSuccess = lprDoc => ({
    type: FETCH_ACCESS_LOG_LPR_DOC_SUCCESS,
    payload: lprDoc
});

export const fetchAccessLogLprDocError = message => ({
    type: FETCH_ACCESS_LOG_LPR_DOC_ERROR,
    payload: message
});

export const clearAccessLogLprDoc = () => ({
    type: CLEAR_ACCESS_LOG_LPR_DOC
});

export const fetchAccessLogDevice = payload => ({
    type: FETCH_ACCESS_LOG_DEVICE,
    payload
});

export const fetchAccessLogDeviceSuccess = payload => ({
    type: FETCH_ACCESS_LOG_DEVICE_SUCCESS,
    payload
});

export const fetchAccessLogDeviceError = payload => ({
    type: FETCH_ACCESS_LOG_DEVICE_ERROR,
    payload
});

export const clearAccessLogDeviceDoc = () => ({
    type: CLEAR_ACCESS_LOG_DEVICE
});

export const fetchAccessLogAccessKey = payload => ({
    type: FETCH_ACCESS_LOG_ACCESS_KEY,
    payload
});

export const fetchAccessLogAccessKeySuccess = payload => ({
    type: FETCH_ACCESS_LOG_ACCESS_KEY_SUCCESS,
    payload
});

export const fetchAccessLogAccessKeyError = payload => ({
    type: FETCH_ACCESS_LOG_ACCESS_KEY_ERROR,
    payload
});

export const clearAccessLogAccessKey = () => ({
    type: CLEAR_ACCESS_LOG_ACCESS_KEY
});

export const fetchAccessLogGuardIdentity = uid => ({
    type: FETCH_ACCESS_LOG_GUARD_IDENTITY,
    payload: uid
});

export const fetchAccessLogGuardIdentitySuccess = identity => ({
    type: FETCH_ACCESS_LOG_GUARD_IDENTITY_SUCCESS,
    payload: identity
});

export const fetchAccessLogGuardIdentityError = message => ({
    type: FETCH_ACCESS_LOG_GUARD_IDENTITY_ERROR,
    payload: message
});

export const clearAccessLogGuardIdentity = () => ({
    type: CLEAR_ACCESS_LOG_GUARD_IDENTITY
});

export const fetchAccessLogApproverInvite = inviteId => ({
    type: FETCH_ACCESS_LOG_APPROVER_INVITE,
    payload: inviteId
});

export const fetchAccessLogApproverInviteSuccess = invite => ({
    type: FETCH_ACCESS_LOG_APPROVER_INVITE_SUCCESS,
    payload: invite
});

export const fetchAccessLogApproverInviteError = message => ({
    type: FETCH_ACCESS_LOG_APPROVER_INVITE_ERROR,
    payload: message
});

export const clearAccessLogApproverInvite = () => ({
    type: CLEAR_ACCESS_LOG_APPROVER_INVITE
});
